import useI18n from "@I18n/hooks/useI18n";
import { messages } from "./messages";

export const dateFromNow = (fromDate: string) => {
  const { formatMessage } = useI18n();
  const date = Number(new Date(fromDate));
  const today = Number(new Date());

  const oneDay = 24 * 60 * 60 * 1000;
  const dayDifference = Math.round(Math.abs((date - today) / oneDay));

  let count;
  let translationKey;

  if (dayDifference >= 360) {
    count = Math.floor(dayDifference / 360);
    translationKey = `yearDateFromNow${count > 1 ? "Plural" : ""}`;
  } else if (dayDifference >= 30) {
    count = Math.floor(dayDifference / 30);
    translationKey = `monthDateFromNow${count > 1 ? "Plural" : ""}`;
  } else {
    count = dayDifference;
    translationKey = `dayDateFromNow${count > 1 ? "Plural" : ""}`;
  }

  return formatMessage(messages[translationKey], { count });
};
